import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';
import {Auto} from '../admin/auto/model/auto';

@Injectable()
export class AutoService {
constructor(private http: Http) { }

 private tagsUrl = 'https://auto.siloq.com/';

     auto(s: string) : Observable<Auto[]> {
         return this.http.get(this.tagsUrl + "auto/" + s)
	 .map((res:Response) => 
	 //{
	 //	res.headers.set('Access-Control-Allow-Origin', 'https://siloq.com');
	 res.json()
	 //;
	 //}
	 )
            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
     }

     complete(s: string) : Observable<Auto[]> {
         return this.http.get(this.tagsUrl + "complete/" + s)
	 /* .map((res:Response) => 
	 //{
	 //res.headers.set('Access-Control-Allow-Origin', 'https://siloq.com');
	 res.json()
	 //;
		//	}
		)
		*/
	       	.catch((error:any) => Observable.throw(error.json().error || 'Server error'));
     }
}



// WEBPACK FOOTER //
// ./src/app/services/auto.service.ts